<!-- 盘点历史 -->

<template>
    <div class="get-with-draw">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                      <div class="change-type" >
                            <span>发起提现后，平台将统一于每周二划款，请注意查收。如有疑问，请电联13980547109(微信同号)</span>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:10%">序号</th>
                                <th style="width:10%">提现人</th>
                                <th style="width:10%">提现金额</th>
                                <th style="width:10%">划账金额</th>
                                <th style="width:10%">平台扣费</th>
                                <th style="width:30%">提现账号</th>
                                <th style="width:5%">提现状态</th>
                                <th style="width:15%">日期</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:withdrawData.length>10}" v-if="withdrawData.length>0">
                                    <tr v-for="(item,ind) in withdrawData" :key="ind">
                                        <td style="width:10%">
                                            <span v-text="ind+1"></span>
                                        </td>
                                        <td style="width:10%">{{item.accountPeople}}</td>
                                        <td style="width:10%">{{item.amount}}</td>
                                        <td style="width:10%">{{item.accountingAmount}}</td>
                                        <td style="width:10%">{{"10%"}}</td>
                                        <td style="width:30%">{{item.accountPayee}}</td>
                                        <td style="width:5%">{{item.accounting?"成功":"提现中"}}</td>
                                        <td style="width:15%">{{item.withdrawTime | dateForGradePage}}</td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <!-- <span class="left item">数量:<span class="num color3" v-text="allQty"></span></span> -->
                        <!-- <span class="left item">总收入:<span class="num color5">{{allAmount | toFixedNum}}</span></span> -->
                        <span class="right">
                            <el-pagination background layout="prev, pager, next" :page-size="size" :total="totalElements" @current-change="handleCurrentChange">
                            </el-pagination>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
export default {
  props: ["curStoreId", "pageSize"],
  data() {
    return {
      allAmount: 0, //总金额
      allQty: 0, //总数量
      withdrawData: [],
      getBtn: true, // 控制翻页请求
      size: 10,
      totalElements: 0
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.getWithdrawData(this.curStoreId, val - 1);
    },
    getWithdrawData(storeId, page) {
      this.$http({
        url: "get-withdraw",
        method: "GET",
        params: {
          storeId,
          page,
          size: this.size
        }
      }).then(res => {
        console.log(res);
        if (res.status == 200) {
          this.withdrawData = res.data.content;
          this.totalElements = res.data.totalElements;
        }
      });
    }
  },
  activated: function() {
    this.getWithdrawData(this.curStoreId, 0);
  }
};
</script>
<style lang="scss">
@import "../../../../../static/css/common.scss";
@import "../../../tableTemplate/tableTem.scss";
@import "./getWithdraw.scss";
</style>



// WEBPACK FOOTER //
// getWithdraw.vue?2847acb1